(ns manage.resource.product-selector
  (:require [common.url-template :as url-tpl]
            [re-frame.core :as rf]))

(rf/reg-event-fx :resource.product-selector/get-result-by-id
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :preview-auth-token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context preview-auth-token] :as cofx} [_ product-selector-id]]
    {:http
     {:method :get
      :uri (url-tpl/render :api/product-selector-result (assoc url-context :product-selector-id product-selector-id))
      :headers {:Authorization (or preview-auth-token (:resource.user/token cofx))}
      :on-success [:resource.product-selector/get-result-success product-selector-id]
      :on-failure [:resource.product-selector/get-result-failure product-selector-id]}}))

(rf/reg-event-db :resource.product-selector/get-result-success
  identity)

(rf/reg-event-db :resource.product-selector/get-result-failure
  identity)
